<div class="body-part">
  <h5>2. {{ 'auth.2fa.email.title' | translate }}</h5>

  <p>
    {{ 'auth.2fa.email.description' | translate }}
  </p>
</div>

<form [formGroup]="emailForm">
  <cap-input
    type="text"
    styleClass="w-100 mt-3"
    formControlName="email">
  </cap-input>

  <cap-button
    type="submit"
    [class.btn-disabled]="emailForm.invalid"
    [disabled]="emailForm.invalid || clicked"
    class="w-100"
    styleClass="primary w-100"
    [label]="(emailSent ? 'auth.2fa.email.button.resend' : 'auth.2fa.email.button.send') | translate"
    (click)="sendEmail()">
  </cap-button>

  <h6 class="done-text mt-3 mb-4" *ngIf="emailSent">
    <i [ngClass]="fontAwesomeIcon.CheckCircle"></i> {{ 'auth.2fa.email.send' | translate }}
  </h6>
</form>
